import React from 'react'
import Image from 'gatsby-image'
import { Link } from 'gatsby'
import AddToCart from './addToCart'

const ProductCard = ({ product }) => {
  return (
    <div className="card--product">
      <Image className="card--product__image" fluid={product.image.fluid} loading="eager" durationFadeIn={250}/>
      <div className="card--product__container">
        <div className="content">
          <span class="category">{product.category.name}</span>
          <h2 className="h4 text-black">{product.title}</h2>
          <div className="price--container">
            <span
              className={`price ${product.pricePromo ? 'price--erased' : ''}`}
            >
              {new Intl.NumberFormat('fr-FR', {
                style: 'currency',
                currency: 'EUR',
              }).format(product.price)}
            </span>
            {product.pricePromo && (
              <span className="price price--promo">
                {new Intl.NumberFormat('fr-FR', {
                  style: 'currency',
                  currency: 'EUR',
                }).format(product.pricePromo)}
              </span>
            )}
          </div>
        </div>
        <div className="cta-area">
         <AddToCart 
         id={product.id}
         price={product.price}
         url="babycommerce.netlify.app/catalogue"
         image={product.image.fluid.src}
         name={product.title}
         buttonText="Ajouter"
         />
          <Link
            className="button primary-dark"
            to={`/produits/${product.slug}`}
          >
            Voir
          </Link>
        </div>
      </div>
    </div>
  )
}

export default ProductCard
